import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { Toaster } from "@/components/ui/sonner";

export default function AppLayout({ children }) {
  return (
    <div className="min-h-screen flex bg-[#F8FAFC]">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar />
        <main className="flex-1 p-6 lg:p-8 overflow-y-auto fadein">{children}</main>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
